<template>
  <b-dropdown
    id="transaction-notification"
    position="is-bottom-left"
    mobile-modal
  >

    <div
      slot="trigger"
      class="noti-box"
      @click="markAllNotiAsRead()"
    >
      <img src="/static/svg/notifications.svg">
      <div
        v-if="unreadTxHistoryAmount + unreadUserNotiAmount > 0"
        class="noti-circle"
      >
        {{ unreadTxHistoryAmount + unreadUserNotiAmount }}
      </div>
    </div>

    <b-dropdown-item
      v-if="notificationList.length === 0"
      custom
    >
      <div class="empty-notification">
        <img
          src="/static/svg/icon-empty-notification.svg"
          width="84px"
          height="91px"
        >
        <div>
          <h1 class="header-empty-notification">
            {{ $t('notification.nothing_here') }}
          </h1>
          <span>
            {{ $t('notification.have_no_noti') }}
          </span>
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item
      v-for="h in notificationList"
      v-else
      :key="h.transactionHash"
      :class="['tx-dd-item', { 'is-unread': isUnread(h) }]"
      @click="readNoti(h)"
    >
      <div class="txs-icon">
        <img
          v-if="h.type === 'RECEIVE_REWARD' || h.type === 'RECEIVE_REFERRAL_PROGRAM_REWARD'"
          src="/static/svg/noti-icon-trophy.svg"
        >
        <img
          v-else-if="h.type === 'GET_FREE_REWARD' || h.type === 'GET_FREE_REFERRAL_PROGRAM_REWARD'"
          src="/static/svg/noti-icon-treasure.svg"
        >
        <img
          v-else-if="h.type === 'TRADING' && h.status === 'success'"
          src="/static/svg/noti-complete.svg"
        >
        <img
          v-else-if="h.type === 'TRADING' && h.status === 'fail'"
          src="/static/svg/noti-fail.svg"
        >
        <img
          v-else-if="h.type === 'TRADING' && h.status === 'in progress'"
          src="/static/svg/noti-onprocess.svg"
        >
        <img
          v-else-if="h.type === 'TAKE_THE_SUIT_TEST'"
          src="/static/svg/icon-suitability-test.svg"
        >
        <img
          v-else-if="h.type === 'TAKE_THE_KNOWLEDGE_TEST'"
          src="/static/svg/icon-knowledge-test.svg"
        >
      </div>
      <div class="txs-container">
        <div
          :class="['hash-box', {
            'tx-success': h.type === 'TRADING' && h.status === 'success',
            'tx-fail': h.type === 'TRADING' && h.status === 'fail',
            'tx-inprogress': h.type === 'TRADING' && h.status === 'in progress',
          }]"
        >
          <div class=" text-title">
            <p v-if="h.type === 'TRADING'">
              {{ h.fromAsset.code }} -> {{ h.toAsset.code }}
            </p>
            <p v-else>
              {{ $t(`notification.${transformPascelCaseToSnakeCase(h.name)}`) }}
            </p>
          </div>
          <div class=" tx-amount-text">
            <p v-if="h.type === 'TRADING'">
              {{ h.fromAmount | numberWithComma }} -> {{ h.toAmount | numberWithComma }}
            </p>
            <p v-else>
              {{ $t(`notification.sub_${transformPascelCaseToSnakeCase(h.name)}`) }}
            </p>
          </div>
        </div>
        <div
          :class="['status-box', {
            'tx-success': h.status === 'success',
            'tx-fail': h.status === 'fail',
            'tx-inprogress': h.status === 'in progress',
          }]"
        >
          <div v-if="h.type === 'TRADING'">
            <span v-if="h.status === 'success'">{{ $t('notification.success') }}</span>
            <span v-if="h.status === 'fail'">{{ $t('notification.failed') }}</span>
            <span v-if="h.status === 'in progress'">{{ $t('notification.on_process') }}</span>
          </div>
          <div class="time-ago-box ">
            <timeago :datetime="h.timestamp * 1000"/>
          </div>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Service from './service.js'
import KulapService from '@/services/kulap'
import { kulapApi } from '@/resources'
import { getEterScanUrl } from '@/environments'

export default {
  name: 'Notification',
  data () {
    return {
      service: null
    }
  },
  computed: {
    ...mapGetters({
      userDefaultWallet: 'userDefaultWallet',
      sortTransactionHistory: 'sortTransactionHistory',
      sortUserNotification: 'sortUserNotification'
    }),
    ...mapState({
      isWalletConnected: state => state.isWalletConnected,
      unreadTxHistoryAmount: state => state.unreadTxHistoryAmount,
      unreadUserNotiAmount: state => state.unreadUserNotiAmount,
      notiUnread: state => state.notiUnread,
      currentNetwork: state => state.currentNetwork,
      user: state => state.user
    }),
    notificationList () {
      if (this.sortTransactionHistory.length || this.sortUserNotification.length) {
        const notifications = this.sortTransactionHistory.concat(this.sortUserNotification)
        return notifications.sort((first, sec) => sec.timestamp - first.timestamp)
      } else {
        return []
      }
    },
    lengthOfUserNotificationUnRead () {
      if (this.sortUserNotification.length) {
        return this.sortUserNotification.filter(noti => !noti.isRead).length
      } else {
        return 0
      }
    },
    userNotificationList () {
      if (this.user && this.user.notifications) {
        return this.user.notifications
      } else {
        return []
      }
    }
  },
  watch: {
    async userDefaultWallet (val, oldVal) {
      if (val !== 'unknown') {
        await this.getTransactionHistory()
      }
    },
    user (val) {
      if (Object.keys(val).length === 0) { // When logout
        this.markAllNotiAsRead()
      }
    },
    userNotificationList (newVal, oldVal) {
      const cacheUserNotiAmount = localStorage.getItem(`KULAP.unread-user-noti-amount-${this.user.id}`)
      if (cacheUserNotiAmount !== null && parseInt(cacheUserNotiAmount) !== 0) {
        const newValAmount = newVal.filter(val => !val.isRead).length
        const oldValAmount = oldVal.filter(val => !val.isRead).length
        if (newValAmount > parseInt(cacheUserNotiAmount) && newValAmount > oldValAmount && oldValAmount > 0) {
          const amount = parseInt(cacheUserNotiAmount) + newValAmount - oldValAmount
          this.$nextTick(() => {
            this.service.setUnreadUserNotiAmount(amount, this.user.id)
          })
        } else {
          this.service.setUnreadUserNotiAmount(parseInt(cacheUserNotiAmount), this.user.id)
        }
      } else {
        const amount = newVal.filter(val => !val.isRead).length
        this.service.setUnreadUserNotiAmount(amount, this.user.id)
      }
    }
  },
  async created () {
    // Initial kulapApi and $store first because we have to use service before initialing kulapDex success.
    this.service = new Service({ store: this.$store, kulapApi })
    const kulapDex = new KulapService()
    await kulapDex.init()
    this.service = new Service({ store: this.$store, kulapApi, kulapDex })
  },
  methods: {
    async getTransactionHistory () {
      await this.service.getTradeHistory(this.userDefaultWallet, this.currentNetwork)
      this.setNotiByLocalStorage()
    },
    markAllNotiAsRead () {
      this.service.setUnreadTxHistoryAmount(0, this.userDefaultWallet, this.currentNetwork)
      this.service.setUnreadUserNotiAmount(0, this.user.id)
    },
    setNotiByLocalStorage () {
      const lcData = localStorage.getItem(`KULAP.unread-noti-${this.currentNetwork}-${this.userDefaultWallet}`)
      const cacheUnreadTxAmount = localStorage.getItem(`KULAP.unread-tx-history-amount-${this.currentNetwork}-${this.userDefaultWallet}`)
      const lcUnreadTxHistoryAmount = cacheUnreadTxAmount ? parseInt(cacheUnreadTxAmount) : 0
      const unread = lcData ? JSON.parse(lcData) : []
      let result = []
      if (unread.length) {
        unread.forEach((ur) => {
          const isExits = !!this.sortTransactionHistory.find(tx => tx.transactionHash === ur)
          if (isExits) result.push(ur)
        })
      }
      this.service.setUnreadTxHistoryAmount(lcUnreadTxHistoryAmount || 0, this.userDefaultWallet, this.currentNetwork)
      this.service.markTxHistoryAsUnread(result)
      if (this.sortTransactionHistory[0] && this.sortTransactionHistory[0].blockNumber) {
        localStorage.setItem(`KULAP.noti-latest-block-height-${this.currentNetwork}-${this.userDefaultWallet}`, this.sortTransactionHistory[0].blockNumber)
      }
    },
    async readNoti (noti) {
      if (noti.type === 'TRADING') {
        const hash = noti.transactionHash
        const lcData = localStorage.getItem(`KULAP.unread-noti-${this.currentNetwork}-${this.userDefaultWallet}`)
        const unread = lcData ? JSON.parse(lcData) : []
        let newUnread = unread.filter(tx => tx !== hash)
        this.service.markTxHistoryAsUnread(newUnread)
        localStorage.setItem(`KULAP.unread-noti-${this.currentNetwork}-${this.userDefaultWallet}`, JSON.stringify(newUnread))
        window.open(`${getEterScanUrl(this.currentNetwork)}/tx/${hash}`, '_blank')
      } else {
        if (!noti.isRead) {
          noti.isRead = true
          await this.service.markUserNotificationAsRead(noti.timestamp)
        }
        if (noti.name === 'GetConnectWithFacebookReward' || noti.name === 'GetConnectWithGoogleReward' || noti.name === 'GetSubscribeNewsLetterReward') {
          if (this.$router.currentRoute.name === 'UserProfile') {
            this.$scrollTo('#section-social-connect')
          } else {
            this.$router.push({ name: 'UserProfile', hash: '#section-social-connect' })
          }
        } else if (noti.name === 'GetKYCApprovedReward') {
          this.$router.push({ name: 'KYC' })
        } else if (noti.name === 'GetReferralProgramReward') {
          this.$router.push({ name: 'ReferralProgram' })
        } else if (noti.name === 'ReceivedReferralProgramReward') {
          if (this.$router.currentRoute.name === 'ReferralProgram') {
            this.$scrollTo('#section-referral-data')
          } else {
            this.$router.push({ name: 'ReferralProgram', hash: '#section-referral-data' })
          }
        } else if (noti.name === 'ReceivedKYCApprovedReward') {
          if (this.$router.currentRoute.name === 'SummaryOfKYC') {
            this.$scrollTo('#section-kyc-data')
          } else {
            this.$router.push({ name: 'SummaryOfKYC', hash: '#section-kyc-data' })
          }
        } else if (noti.name === 'TakeTheSuitabilityTest') {
          this.$router.push({ name: 'SuitabilityTest' })
        } else if (noti.name === 'TakeTheKnowledgeTest') {
          this.$router.push({ name: 'KnowledgeTest' })
        }
      }
    },
    isUnread (noti) {
      if (noti.type === 'TRADING') {
        return this.notiUnread.find(h => h === noti.hash)
      } else {
        return !noti.isRead
      }
    },
    transformPascelCaseToSnakeCase (pascelString) {
      return pascelString.replace(/\.?([A-Z]+)/g, function (x, y) { return '_' + y.toLowerCase() }).replace(/^_/, '')
    }
  }
}
</script>

<style lang="scss">
#transaction-notification {
  .dropdown-menu  {
    border-radius: 4px;
  }
}
#transaction-notification {
  .dropdown-content {
    float: left;
    width: 100%;
    max-height: 400px;
    overflow: auto;
    padding: 0;

    .dropdown-item:hover {
      background-color: #d6eaff;
    }
  }
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  #transaction-notification {
    .dropdown-content {
      max-height: calc(100vh - 120px);
    }
  }
}
</style>

<style lang="scss" scoped>
.noti-box {
  position: relative;
  cursor: pointer;
  width: fit-content;
}
.noti-circle {
  position: absolute;
  top: -12px;
  right: -17px;
  background-color: #00aeff;
  color: #fff;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  text-align: center;
  line-height: 25px;
  border-radius: 50%;
}
.not-connect-notification {
  width: 230px;
  height: 200px;
  padding-top: 30px;
  text-align: center;
}
.empty-notification {
  width: 320px;
  height: 230px;
  padding-top: 30px;
  text-align: center;
}
.header-empty-notification {
  font-weight: bold;
  margin-top: 24px;
}
.tx-dd-item {
  padding: 15px 15px;
  float: left;
  width: 400px;
  border-bottom: solid 1px #c6c6c6;
}
.txs-icon {
  float: left;
  padding-top: 5px;
  width: 35px;

  img {
    width: 80%;
  }
}
.txs-container {
  float: left;
  width: calc(400px - 35px - 10px - 30px);
  margin-left: 10px;
}
.is-unread {
  background-color: #d6eaff;
}
.hash-box {
  float: left;
  width: 50%;
  font-size: 14px;
  font-weight: bold;
  text-align: left !important;
}
.status-box {
  float: left;
  width: 50%;
  font-size: 14px;
  font-weight: bold;
  text-align: right;
}
.time-ago-box {
  font-size: 11px;
  color: #545454;
  font-weight: 300;
}
.tx-success {
  color: #3eaf34;
}
.tx-fail {
  color: #ff0000;
}
.tx-inprogress {
  color: #0096ed;
}
.text-title {
  color: #0559af;
}
.tx-amount-text {
  color: #a7a7a7;
  font-size: 13px;
}
/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .not-connect-notification {
    width: 100%;
  }
  .empty-notification {
    width: 100%;
  }
  .tx-dd-item {
    width: 100%;
    padding: 10px !important;
  }
  .txs-container {
    width: calc(100% - 35px - 5px);
    margin-left: 5px;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .noti-box {
    float: right;
    margin-right: 10px;
  }
  .text-title {
    word-wrap: break-word;
    white-space: normal;
  }
  .tx-amount-text {
    word-wrap: break-word;
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/Notification/index.vue